import React from "react";

import { Inline } from "@seneca/senekit";

import CircularProgressBar, {
  SIZES
} from "features/common/progress-indicators/circular-progress-indicator";
import { isMobile } from "features/common/utils/functions/mobile";

type Props = {
  value: number | null | undefined;
  children: React.ReactElement;
};

export default function ScoreIndicator({ value, children }: Props) {
  return (
    <Inline space="small" alignItems="center" flexWrap="nowrap">
      {!isMobile() && (
        <CircularProgressBar
          progress={value as any}
          size={SIZES.XSMALL as any}
          strokeWidth={22}
          isThemed
        />
      )}
      {children}
    </Inline>
  );
}
